export default function Header() {
  return (
    <div
      className="pb-12 pt-4 flex items-center justify-center"
      style={{ backgroundColor: "#231C5E" }}
    >
      <h2 className="text-white">How can we help you?</h2>
    </div>
  );
}
